import React, { useState } from 'react';
import DialogHeader from '../DialogHeader';
import {
  Button,
  Grid,
  makeStyles,
  SwipeableDrawer,
  TextField,
  Typography,
} from '@material-ui/core';
import EditWarehouseDetails from './EditWarehouseDetails';
import EditWarehouseStatus from './EditWarehouseStatus';
import DeleteWarehouse from './DeleteWarehouse';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  backdrop: {
    '& .MuiBackdrop-root ': {
      backgroundColor: 'transparent !important',
      opacity: '0 !important',
    },
  },
}));

const ViewEditWarehouse = (props) => {
    const classes = useStyles();
    const warehouseDetails = {
        warehouseName: 'CWH - Bhiwandi',
        warehouseMainAddress:
            'Ground floor, Survey No. 94/1, 94/2 Khata no. 199/1, 199/2, Koralur Village Kasabahobli, Hoskote, Taluk, Bengaluru, Karnataka 560067',
    pickupAddress: 'pickupAddress',
        deliveryAddress: 'delivery address',
        warehouseCode: 'L903',
        associatedTeamMembers: [
            {
                saasUserId: 200,
                name: 'Rajesh',
                department: 'Logistic and warehouse',
                roleName: 'Head',
            },
            {
                saasUserId: 201,
                name: 'Anjali',
                department: 'Operations',
                roleName: 'Supervisor',
            },
        ],
        associatedCDMOs: [
            {
                organizationId: 1,
                organizationName: 'Lupin',
                teamMembers: [
                    {
                        saasUserId: 300,
                        name: 'Suraj',
                        department: 'Logistic and warehouse',
                        role: 'Manager',
                    },
                    {
                        saasUserId: 301,
                        name: 'Kavya',
                        department: 'Quality Control',
                        role: 'Assistant Manager',
                    },
                ],
            },
        ],
        status: 'Active',
    };
    const [openDialogBox, setDialogBox] = useState({
        open: false,
        type: '',
        parameter: null,
      });
    
      const handleDialogBox = (type, value) => {
        setDialogBox({
          open: !openDialogBox.open,
          type: type,
          parameter: value,
        });
      };
    
      const handleCloseDialogBox = () => {
        setDialogBox({
          open: false,
          type: '',
          parameter: null,
        });
      };

  return (
    <div className={classes.list}>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <DialogHeader header={'View Warehouse'} />
        </Grid>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Button
              variant='outlined'
                          style={{ textTransform: 'none' }}
                          onClick={() => handleDialogBox('EditWarehouse', warehouseDetails)}
            >
              Edit warehouse
            </Button>
            <Button
              variant='contained'
              color='secondary'
                          style={{ textTransform: 'none' }}
                          onClick={() => handleDialogBox('EditStatus', warehouseDetails)}
            >
              Edit warehouse status
                      </Button>
                      <Button
              variant='contained'
              color='secondary'
                          style={{ textTransform: 'none' }}
                          onClick={() => handleDialogBox('DeleteWarehouse', warehouseDetails)}
            >
              Delete warehouse
            </Button>
          </Grid>
        </Grid>
          </Grid>
          {openDialogBox.open && (
        <SwipeableDrawer
          anchor={'right'}
          open={openDialogBox.open}
                  onOpen={() => handleDialogBox(openDialogBox.type, warehouseDetails)}
                  onClose={()=>handleCloseDialogBox()}
          className={classes.backdrop}
        >
          {openDialogBox.type === 'EditWarehouse' && (
            <EditWarehouseDetails
              handleClose={() =>
                setDialogBox({
                  open: false,
                  parameter: null,
                })
              }
              warehouseDetails={warehouseDetails}           
            />
          )}
          {openDialogBox.type === 'EditStatus' && (
            <EditWarehouseStatus
                          handleClose={() => handleCloseDialogBox()}
                          warehouseDetails={warehouseDetails}  
            />
                  )}
                  {openDialogBox.type === 'DeleteWarehouse' && (
            <DeleteWarehouse
              handleClose={() => handleCloseDialogBox()}
            />
          )}
        </SwipeableDrawer>
      )}
    </div>
  );
};

export default ViewEditWarehouse;
